<template>
  <div>
    
    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="title is-4">
          タブの作り方
        </p>
      </div>
    </section>

    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          1. Searchボタンをタップ
        </p>
        <img src="../../assets/tutorial1_1.png" width="350px">
      </div>
    </section>


    <section class="hero">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          2. ワードを入力して検索
        </p>
        <img src="../../assets/tutorial1_2.png" width="350px">
      </div>
    </section>

    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          3. Home画面へ戻る
        </p>
        <img src="../../assets/tutorial1_3.png" width="350px">
      </div>
    </section>

    <section class="hero">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          4. 自動でタグ付けされます。
        </p>
        <img src="../../assets/tutorial1_4.png" width="350px">
      </div>
    </section>

    <section class="hero" >
      <div class="hero-body has-text-right" style="padding-bottom: 0; padding-right:35px">
        <img src="../../assets/arrow3.png" width="100px" height="100px">
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'ios',
  mounted() {
    document.title = "1.タブの作り方"
    const description = "基本操作のタブ作成のチュートリアルです。"
    document.querySelector('head meta[name="description"]').setAttribute('content', description);
    document.querySelector('head meta[property="og:description"]').setAttribute('content', description);
	},
};
</script>

<style lang="scss" scoped>
.is-white {
    background-color:#fcfcfc !important;
}

.title, .subtitle {
  letter-spacing: 0.1em;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Yu Gothic", YuGothic, Verdana, Meiryo, "M+ 1p", sans-serif;
}

.title {
 opacity: 0.85;
}

.hero-body {
  padding-left:12px;
  padding-right:12px;
}
</style>

